export default /^[A-Z0-9+](\.?[A-Z0-9_+-])*@[A-Z0-9-]+(\.[A-Z]{2,})+$/i;